// extracted by mini-css-extract-plugin
export default {"tableContainer":"Users_tableContainer__3NVjk","pageTabContaner":"Users_pageTabContaner__xv9Mp"};